// src/BookingConfirmation.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function BookingConfirmation() {
    const location = useLocation();
    const booking = location.state?.booking;

    if (!booking) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center p-8">
                <p className="text-red-600 text-lg mb-4">⚠️ 沒有找到預約資料。</p>
                <Link to="/" className="text-blue-600 hover:underline">
                    返回首頁
                </Link>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-8">
            <h1 className="text-2xl font-bold text-green-600 mb-4">✅ 預約成功！</h1>
            <div className="bg-white shadow rounded p-6 w-full max-w-md space-y-3">
                <p><strong>姓名：</strong> {booking.name}</p>
                <p><strong>聯絡方式：</strong> {booking.contact}</p>
                <p><strong>治療部位：</strong> {booking.bodyPart}</p>
                <p><strong>預約日期：</strong> {booking.preferredDate}</p>
                <p><strong>預約時間：</strong> {booking.timeSlot}</p>
                <p><strong>治療師：</strong> {booking.therapistName}</p>
                <p><strong>備註：</strong> {booking.notes || '無'}</p>
            </div>

            <Link
                to="/"
                className="mt-6 inline-block bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
                返回首頁
            </Link>
        </div>
    );
}
